{
    "firebase": {
        "apiKey": "AIzaSyBlIM4LtpCaonZkHKar-QGAh1oaHAgKgEI",
        "authDomain": "flightline-odyssey-1823e.firebaseapp.com",
        "databaseURL": "https://flightline-odyssey-1823e-default-rtdb.firebaseio.com",
        "projectId": "flightline-odyssey-1823e",
        "storageBucket": "flightline-odyssey-1823e.firebasestorage.app",
        "messagingSenderId": "638860155",
        "appId": "1:638860155:web:18c31de9ef7a84fcc6dbde"
    },
    "clientName": "Odyssey",
    "pdfViewerKey": "677c18f9b10f46dc9a3380def61a81ab",
    "domains": ["flightline-odyssey-1823e.web.app"]
}
